const shortId = (uuid: string) => uuid.slice(0, 8);

export default shortId;
